import { createContext, useContext } from 'react';
import { FocusFile } from '../shared/file-importer/types';

interface FocusImportProviderProps {
    activityId: string;
    focusFile?: FocusFile;
    setFocusFile: (file: FocusFile | undefined) => void;
}

interface FocusImportContextProps {
    activityId: string;
    focusFile?: FocusFile;
    setFocusFile: (file: FocusFile | undefined) => void;
}

const FocusImportContext = createContext<FocusImportContextProps>({
    activityId: '',
    focusFile: undefined,
    setFocusFile: () => undefined,
});

export const FocusImportProvider: React.FC<React.PropsWithChildren<FocusImportProviderProps>> = (props) => {
    const { activityId, focusFile, setFocusFile, children } = props;

    const contextValue = { activityId: activityId, focusFile: focusFile, setFocusFile: setFocusFile };

    return <FocusImportContext.Provider value={contextValue}>{children}</FocusImportContext.Provider>;
};

export const useFocusImport = () => useContext<FocusImportContextProps>(FocusImportContext);
